import { useEffect, useRef, useState } from "react";
import {
    ShoppingBagIcon,
    GiftIcon,
    UserIcon,
    PlusIcon,
    ChatBubbleBottomCenterIcon,
    TicketIcon,
    DocumentTextIcon
} from "@heroicons/react/24/outline";
import NavBar from "../../components/Navigation/NavBar";
import RentItems from "../../components/Profile/RentItems";
import SellItems from "../../components/Profile/SellItems";
import RentItemModal from "../../components/Modal/RentItemModal";
import RewardsPage from "../../components/Profile/Rewards";
import SellItemModal from "../../components/Modal/SellItemModal";
import MessageCard from "../../components/MessageCard";
import { useAuth } from "../../context/AuthContext";
import SGloopMainList from "../../components/Profile/SGloopMainList";
import UserProfileCard from "../../components/Profile/UserProfileCard";
import SummaryCard from "../../components/Profile/SummaryCard";
import { getLoginUserRental } from "../../services/firestore/rentalService";
import FormsModal from "../../components/Modal/FormsModal";
import FormsModalv2 from "../../components/Modal/FormsModalv2";
import { getFormsForUser, listenFormsForUser } from "../../services/firestore/formService";
import FormsItems from "../../components/Profile/FormsItems";
import { useNavigate } from "react-router-dom";
import MembershipCardList from "../../components/Profile/MembershipCardList";

export default function ProfileHomePage() {
    const [tab, setTab] = useState("Forms");
    const [openRent, setOpenRent] = useState(false);
    const [openSell, setOpenSell] = useState(false);
    const [openServices, setOpenServices] = useState(false);
    const [openForms, setOpenForms] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("Active");
    const [rentalItem, setRentalItems] = useState([]);
    const [formsItems, setFormsItems] = useState([]);
    const { user, userData } = useAuth();
    const scrollRef = useRef(null);
    const [editingForm, setEditingForm] = useState(null);
    const navigate = useNavigate();

    const SelectTab = (response) => {
        setTab(response);
        if (scrollRef.current) {
            scrollRef.current.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    };
    useEffect(() => {
        if (user) {
            // user just logged in
            const routeback = sessionStorage.getItem("routeback");
            if (routeback) {
                sessionStorage.removeItem("routeback");
                navigate(routeback);
            }
        }
    }, [user]);
    useEffect(() => {
        if (userData) {
            getLoginUserRental(userData).then((rentalRes) => {
                setRentalItems(rentalRes);
            })
            const unsubscribe = listenFormsForUser(userData.uid, (updatedForms) => {
                setFormsItems(updatedForms);
            });

            return () => unsubscribe();
        }
    }, [userData]);
    const filteredForms = formsItems.filter((form) => form.status === selectedStatus);
    return (
        <div className="min-h-screen bg-gradient-to-b from-[#31639126] to-white flex flex-col">
            <NavBar />

            {/* Mobile Tab Bar */}
            <div className="md:hidden sticky top-[5rem] border-t bg-white py-3 z-10 overflow-x-auto scrollbar-hide">
                <div className="flex justify-start space-x-6 px-4 snap-x snap-mandatory">
                    {[
                        // { name: "Shop", icon: ShoppingBagIcon },
                        // { name: "Ticketing", icon: TicketIcon },
                        // { name: "Message", icon: ChatBubbleBottomCenterIcon },
                        // { name: "Rewards", icon: GiftIcon },
                        { name: "Forms", icon: DocumentTextIcon },
                        { name: "Membership", icon: DocumentTextIcon },
                        { name: "Profile", icon: UserIcon },
                    ].map((item, idx, arr) => (
                        <button
                            key={item.name}
                            className={`flex flex-col items-center flex-shrink-0 snap-start ${tab === item.name ? "text-blue-600" : "text-gray-500"
                                } ${idx === arr.length - 1 ? "pr-6" : ""}`} // add spacing on last to peek
                            onClick={() => SelectTab(item.name)}
                        >
                            <item.icon className="w-6 h-6" />
                            <span className="text-xs">{item.name}</span>
                        </button>
                    ))}
                </div>
            </div>


            {/* Main Content Wrapper */}
            <div ref={scrollRef} className="flex-1 container mx-auto px-4 md:px-8 pb-4 md:pb-8 grid md:grid-cols-12 gap-6 pt-[6rem] md:pt-28 overflow-y-auto">
                {/* Left Sidebar (Profile Info) */}
                <aside className="hidden md:block md:col-span-3 space-y-6">
                    <UserProfileCard userData={userData} tab={tab} setTab={setTab} />
                    <SummaryCard userData={userData} />
                </aside>

                {/* Main Feed */}
                <main className="md:col-span-9 space-y-4">
                    {tab === "Shop" && (
                        <>
                            <div className="bg-white rounded-2xl shadow p-4">
                                <div className="flex items-center justify-between">
                                    <h3 className="font-semibold">Rental</h3>
                                    <button
                                        className="text-gray-600 p-2"
                                        onClick={() => setOpenRent(true)}
                                    >
                                        <PlusIcon className="w-6 h-6" />
                                    </button>
                                </div>
                                <RentItems rentalItem={rentalItem} />
                                <RentItemModal open={openRent} setOpen={setOpenRent} />
                            </div>

                            <div className="bg-white rounded-2xl shadow p-4">
                                <div className="flex items-center justify-between">
                                    <h3 className="font-semibold">Sell</h3>
                                    <button
                                        className="text-gray-600 p-2"
                                        onClick={() => setOpenSell(true)}
                                    >
                                        <PlusIcon className="w-6 h-6" />
                                    </button>
                                </div>
                                <SellItems />
                                <SellItemModal open={openSell} setOpen={setOpenSell} />
                            </div>

                            <div className="bg-white rounded-2xl shadow p-4">
                                <div className="flex items-center justify-between">
                                    <h3 className="font-semibold">Services</h3>
                                    <button
                                        className="text-gray-600 p-2"
                                        onClick={() => setOpenServices(true)}
                                    >
                                        <PlusIcon className="w-6 h-6" />
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                    {tab === "Rewards" && (
                        <div className="bg-white rounded-2xl shadow p-4">
                            <RewardsPage />
                        </div>
                    )}
                    {tab === "Forms" && (
                        <>
                            <div className="bg-white rounded-2xl shadow p-4">
                                <div className="flex items-center justify-between mb-3">
                                    <h3 className="font-semibold text-lg">Forms</h3>
                                    <button
                                        className="text-gray-600 p-2 hover:bg-gray-100 rounded-lg transition"
                                        onClick={() => setOpenForms(true)}
                                    >
                                        <PlusIcon className="w-6 h-6" />
                                    </button>
                                </div>

                                {/* Toggle buttons */}
                                <div className="flex mb-4 bg-gray-100 rounded-lg p-1">
                                    <button
                                        onClick={() => setSelectedStatus("Active")}
                                        className={`flex-1 text-sm font-medium px-3 py-2 rounded-md transition ${selectedStatus === "Active"
                                            ? "bg-blue-600 text-white shadow-sm"
                                            : "text-gray-600 hover:bg-white"
                                            }`}
                                    >
                                        Active
                                    </button>

                                    <button
                                        onClick={() => setSelectedStatus("Closed")}
                                        className={`flex-1 text-sm font-medium px-3 py-2 rounded-md transition ${selectedStatus === "Closed"
                                            ? "bg-blue-600 text-white shadow-sm"
                                            : "text-gray-600 hover:bg-white"
                                            }`}
                                    >
                                        Past Forms
                                    </button>
                                </div>

                                {/* Forms list */}
                                <FormsItems
                                    forms={filteredForms}
                                    onEdit={(form) => {
                                        setEditingForm(form);
                                        setOpenForms(true);
                                    }}
                                />

                                {/* Modal */}
                                {!editingForm || editingForm.backendVersion === 2 ? (
                                    <FormsModalv2
                                        open={openForms}
                                        onClose={() => setOpenForms(false)}
                                        formData={editingForm}
                                        setEditingForm={setEditingForm}
                                        setOpen={setOpenForms}
                                    />
                                ) : (
                                    <FormsModal
                                        open={openForms}
                                        setOpen={setOpenForms}
                                        editingForm={editingForm}
                                        setEditingForm={setEditingForm}
                                    />
                                )}
                            </div>
                        </>
                    )}
                    {tab === "Message" && (
                        <div className="bg-white rounded-2xl shadow py-4">
                            <MessageCard />
                        </div>
                    )}
                    {tab === "Profile" && (
                        <div className="space-y-6">
                            <UserProfileCard userData={userData} tab={tab} setTab={setTab} />
                            <SummaryCard userData={userData} />
                        </div>
                    )}
                    {tab === "Membership" && (
                        <div className="bg-white rounded-2xl shadow p-4">
                            <MembershipCardList userData={userData} />
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
}
